'use client'

import {useDomino} from './domino-visiblity-context/domino-visiblity-context.client'
import DominoMobile from './mobile'
import {GameDetailsResponse} from '../types/game-player'
import {GameDetail} from '../types/game'
import {GamesPreferences} from '../api/get-games-preferences'
import {LanguageCodes} from '@app/i18n/settings'

interface Props {
  game: GameDetailsResponse
  similarGames: GameDetail[]
  lang: LanguageCodes
  propertyCode: string
  theme: string
  isIOS: boolean
  translations: Record<string, string>
  subId: string
  gamePreferences: GamesPreferences
}

const DominoUiClient = ({
  game,
  similarGames,
  lang,
  propertyCode,
  theme,
  isIOS,
  translations,
  subId,
  gamePreferences,
}: Props) => {
  const {retryGame, isDominoVisible} = useDomino()
  return (
    isDominoVisible && (
      <DominoMobile
        game={game}
        similarGames={similarGames}
        retryGame={retryGame}
        lang={lang}
        propertyCode={propertyCode}
        theme={theme}
        isIOS={isIOS}
        translations={translations}
        subId={subId}
        gamePreferences={gamePreferences}
      />
    )
  )
}

export default DominoUiClient
